import { computed, ComputedRef, ref } from 'vue'

import { Rhs } from '@/store/modules/stay/smr/types'

export function countRhsPresenceDays(rhs: Rhs): number {
  return rhs.weekDays.split('1').length - 1 + rhs.weekEndDays.split('1').length - 1
}

export function getWeekNbText(rhs: Rhs, withYear = false, short = false): string {
  const prefix = short ? 'S' : 'Sem '
  const suffix = withYear ? `/${rhs.week.year}` : ''

  return `${prefix}${rhs.week.nb}${suffix}`
}

// todo move in frontend-commons
export class CursorHelper<T> {
  private cursor = ref(0)

  constructor(
    private readonly list: T[],
    private maxDisplayedElements: number
  ) {}

  public setCursor(newCursor: number) {
    if (newCursor < 0) {
      this.cursor.value = 0
      return
    }
    if ((newCursor + this.maxDisplayedElements) > this.list.length) {
      this.cursor.value = this.list.length - this.maxDisplayedElements
      return
    }
    this.cursor.value = newCursor
  }

  public moveCursor(step: number) {
    this.setCursor(this.cursor.value + step)
  }

  public displayedElements: ComputedRef<T[]> = computed(() => this.list.slice(this.cursor.value, this.cursor.value + this.maxDisplayedElements))
  public canMove: ComputedRef<boolean> = computed(() => this.maxDisplayedElements < this.list.length)
  public canMoveDown: ComputedRef<boolean> = computed(() => this.cursor.value > 0)
  public canMoveUp: ComputedRef<boolean> = computed(() => (this.cursor.value + this.maxDisplayedElements) < this.list.length)
}
